<template>
  <div class="right_col" role="main" style="min-height: 756px">
    <div class="">
      <div class="page-title">
        <div class="title_left">
          <h3>{{ $t('subMenu.eventList') }}</h3>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="x_panel item_list">
        <div class="x_content">
          <alert
            :title="alertTitle"
            :success-message="$t('common.isSuccess')"
            :error-message="$t('common.isFailure')"
            :alerts="alerts"
            :errors="errors"
            :display="alertDisplay"
            @closeAlert="closeAlert"
          />

          <div class="text-right">
            <router-link
              :disabled="!groupsReady"
              to="/event/event/create"
              class="btn btn-primary"
              >{{ $t('common.create') }}</router-link
            >
            <a
              :href="csvURL"
              :download="csvFileName"
              @click="csvDownLoad"
              class="btn btn-default"
              >{{ $t('common.csvDownload') }}</a
            >
          </div>
          <div
            id="datatable_wrapper"
            class="dataTables_wrapper form-inline dt-bootstrap no-footer"
          >
            <div class="row">
              <div class="col-sm-6">
                <table-length @changeRowPerPage="changeRowPerPageCount" />
              </div>
              <div class="col-sm-6">
                <div id="datatable_filter" class="dataTables_filter">
                  <label
                    >{{ $t('common.search') }}:
                    <input
                      v-model="searchString"
                      @keyup="searchWord"
                      type="search"
                      class="form-control input-sm"
                      placeholder=""
                      aria-controls="datatable"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <app-table
                  :display-items="displayItems"
                  :column-titles="tableHeaderColumns"
                  @buttonClickEvent="buttonClickEvent"
                  @sortTable="sortTable"
                />
              </div>
            </div>
            <pagination
              :page-par-item-count="displayItemPerPageCount"
              :total-item-count="totalItemCount"
              :current-page="currentPage"
              @changePage="changePage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Alert from '@/components/common/alert/Alert'
import Pagination from '@/components/tabale/Pagination'
import TableLength from '@/components/tabale/TableLength'
import Table from '@/components/common/table/Table'
import EventRequest from '@/http/EventRequest'
import { mapGetters } from 'vuex'
import list from '@/mixin/list'
import alert from '@/mixin/alert'
import Papa from 'papaparse'

export default {
  components: {
    Alert,
    Pagination,
    AppTable: Table,
    TableLength,
  },
  mixins: [list, alert],
  data() {
    return {
      tableHeaderColumns: [
        'ID',
        this.$t('common.eventName'),
        this.$t('common.conditionBranch'),
        this.$t('common.behavior'),
        this.$t('common.edit'),
        this.$t('common.delete'),
      ],
      groupsReady: false,
      csvURL: '',
      csvFileName: '',
    }
  },
  computed: {
    ...mapGetters({
      fetchedData: 'event/getEvents',
      fetchedGroups: 'shop/getGroupToShops',
      language: 'settings/getLanguage',
    }),
  },
  watch: {
    fetchedData: function(newFetchedData) {
      const data = newFetchedData
      this.fetchItems = data.list.map((item) => {
        const conditions = this.getConditionsString(item)
        const action = this.getActionsString(item.action)
        return [
          item.eventId,
          item.name,
          conditions,
          action,
          { type: 'edit', id: item.eventId },
          { type: 'destroy', id: item.eventId },
        ]
      })
      this.allItems = this.fetchItems
      this.totalItemCount = this.allItems.length
      this.displayItems = this.allItems.slice(0, this.displayItemPerPageCount)
    },
    fetchedGroups: function(group) {
      if (group.length > 0) {
        this.groupsReady = true
      }
    },
    language() {
      this.$store.dispatch('event/getEvents')
      this.$store.dispatch('shop/getGroups')
    },
  },
  mounted() {
    if (this.$route.params.succeeded === true) {
      this.alertTitle = this.$route.params.title
      this.openSuccessAlert()
    }

    this.$store.dispatch('event/getEvents')
    this.$store.dispatch('shop/getGroups')
  },
  methods: {
    // 条件分類を判定する
    // 1. イベント一覧取得.誕生日=1、またはイベント一覧取得.性別=1または2の場合、「ユーザー属性」と表示
    //    ※ 現在性別は未実装
    // 2. 1以外の場合で、イベント一覧取得.会計金額に値が設定されている、
    //    またはイベント一覧取得.累計金額に値が設定されている、またはイベント一覧取得.商品注文=1の場合、「商品注文」と表示
    //    ※ 累計金額,商品注文は現在未実装
    // 1,2以外の場合は、空欄
    getConditionsString: function(eventRow) {
      if (eventRow.birthMonth === 1) {
        return this.$t('eventInformationPage.userAttribute')
      } else {
        return ''
      }
    },
    // actionに対応する文言を返す
    getActionsString: function(actionValue) {
      if (actionValue === 1) {
        return this.$t('eventInformationPage.emission')
      } else if (actionValue === 2) {
        return this.$t('eventInformationPage.lottery')
      } else if (actionValue === 3) {
        return this.$t('eventInformationPage.video')
      } else {
        return ''
      }
    },
    buttonClickEvent: function(type, id) {
      if (type === 'edit') {
        this.edit(id)
      } else if (type === 'destroy') {
        this.destroy(id)
      }
    },
    edit: function(id) {
      this.$router.push({ name: 'eventFormEdit', params: { id: id } })
    },
    destroy: function(id) {
      if (
        !window.confirm(
          this.$t('eventInformationPage.eventInformationDeletionConfirmation')
        )
      ) {
        return false
      }
      const request = new EventRequest()
      request
        .delete(id)
        .then(() => {
          this.openSuccessAlert()
        })
        .catch((err) => {
          this.openErrorAlert(err.response.data)
        })
        .finally(() => {
          this.alertTitle = this.$t(
            'eventInformationPage.deleteEventInformation'
          )
          this.$store.dispatch('event/getEvents')
        })
    },
    csvDownLoad: function() {
      const content = []
      const headerColumns = this.tableHeaderColumns.concat()
      const tempDisplayItems = this.displayItems.concat()
      headerColumns.splice(4, 2)
      content.push(headerColumns)
      tempDisplayItems.forEach((item) => {
        const tempItem = item.concat()
        tempItem.splice(4, 2)
        content.push(tempItem)
      })
      const config = {
        delimiter: ',',
        header: true,
        newline: '\r\n',
      }
      // 区切り文字へ変換
      const delimiterString = Papa.unparse(content, config)
      // blobへの変換
      const blob = new Blob([delimiterString], { type: 'text/csv' })
      this.csvFileName = 'eventlist'
      this.csvURL = (window.URL || window.webkitURL).createObjectURL(blob)
    },
    sortTable: function(newArray) {
      this.displayItems = newArray
    },
  },
}
</script>
